module.exports = "/_next/static/images/PG-e49acd3e0f2ec283ed9e32f520ba4567.png";